import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full sm:w-1/4 text-center p-3 sm:p-1 justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Reward rate", -1)
const _hoisted_3 = { class: "text-4xl farm-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dustRate * parseInt(_ctx.gems)) + " $DUST/day", 1)
  ]))
}